import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube, ArrowRight, MessageCircle } from 'lucide-react';
import { SITE, NAV_LINKS } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#0e1729] text-slate-300">
      <div className="max-w-[1400px] mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="bg-white inline-block p-3 rounded">
            <img src={SITE.logo} alt={SITE.name} className="h-16 w-auto" />
          </div>
          <p className="mt-5 text-[14px] leading-relaxed text-slate-400">
            Empowering African girls and women with the liberation of education and literacy for a richer Africa.
          </p>
          <div className="flex items-center gap-3 mt-5">
            {[
              { I: Facebook, href: 'https://www.facebook.com/share/1BeHD47JMp/?mibextid=wwXIfr' },
              { I: Instagram, href: 'https://www.instagram.com/molebohengmatlifoundation?igsh=OTRlbTV2dDU1cWRx&utm_source=qr' },
              { I: Youtube, href: 'https://youtube.com/@molebohengmatlifoundationtv?si=a3IgB35-O_Q8q7os' },
            ].map(({ I, href }, i) => (
              <a key={i} href={href} target="_blank" rel="noopener noreferrer" aria-label="social" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#F97559] grid place-items-center transition-colors">
                <I size={15} />
              </a>
            ))}
            <a href={SITE.whatsappChannel} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp Channel" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#25D366] grid place-items-center transition-colors">
              <MessageCircle size={15} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white text-lg font-bold mb-5">Explore</h4>
          <ul className="space-y-3 text-[14px]">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[#F97559] transition-colors inline-flex items-center gap-2">
                  <ArrowRight size={14} className="text-[#F97559]" />{l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/boychild" className="hover:text-[#F97559] transition-colors inline-flex items-center gap-2">
                <ArrowRight size={14} className="text-[#F97559]" />Boy Child Day
              </Link>
            </li>
            <li>
              <a href={SITE.whatsappChannel} target="_blank" rel="noopener noreferrer" className="hover:text-[#25D366] transition-colors inline-flex items-center gap-2">
                <ArrowRight size={14} className="text-[#F97559]" />WhatsApp Channel
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg font-bold mb-5">Contact</h4>
          <ul className="space-y-4 text-[14px]">
            <li className="flex items-start gap-3">
              <span className="w-9 h-9 shrink-0 rounded-full bg-[#F97559] grid place-items-center text-white"><MapPin size={15} /></span>
              <span className="text-slate-400">Woodmead Country Club Estate<br />21 Woodlands Drive, Woodmead<br />Sandton 2196, Johannesburg<br />South Africa</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-9 h-9 shrink-0 rounded-full bg-[#F97559] grid place-items-center text-white"><Mail size={15} /></span>
              <div className="flex flex-col gap-1.5">
                <a href={`mailto:${SITE.email}`} className="hover:text-[#F97559] transition-colors text-slate-400 break-all">{SITE.email}</a>
                <a href="mailto:Ayesp@molebohengmatlifoundation.org.za" className="hover:text-[#F97559] transition-colors text-slate-400 break-all">Ayesp@molebohengmatlifoundation.org.za</a>
                <a href="mailto:Media@molebohengmatlifoundation.org.za" className="hover:text-[#F97559] transition-colors text-slate-400 break-all">Media@molebohengmatlifoundation.org.za</a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-9 h-9 shrink-0 rounded-full bg-[#F97559] grid place-items-center text-white"><Phone size={15} /></span>
              <a href={`tel:${SITE.phone}`} className="hover:text-[#F97559] transition-colors text-slate-400">{SITE.phone}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg font-bold mb-5">Newsletter</h4>
          <p className="text-[14px] text-slate-400 mb-4">Subscribe for updates on our programs and impact.</p>
          <form onSubmit={(e) => { e.preventDefault(); alert('Thanks for subscribing!'); e.target.reset(); }} className="flex bg-white/5 border border-white/10 rounded overflow-hidden">
            <input required type="email" placeholder="Your email" className="flex-1 bg-transparent px-4 py-3 text-sm outline-none placeholder:text-slate-500" />
            <button type="submit" className="bg-[#F97559] hover:bg-[#e65a40] px-4 transition-colors text-white" aria-label="Subscribe"><ArrowRight size={18} /></button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between text-[13px] text-slate-500">
          <p>Copyright ©2026 All rights reserved.</p>
          <p><span className="text-[#F97559]">Moleboheng Matli Foundation</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
